import React from 'react';
import { X, Star } from 'lucide-react';
import { Button } from '../../ui/button';

const ReviewRequestModal = ({
  isOpen,
  onClose,
  estimate,
  isRequesting,
  onSubmit
}) => {
  if (!isOpen) return null;

  const customerFullName = estimate?.customer_name || 
    `${estimate?.customer_first_name || ''} ${estimate?.customer_last_name || ''}`.trim() || 'No name';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
            <Star className="w-6 h-6 text-yellow-600" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Request a Review</h3>
            <p className="text-sm text-gray-600">Start an automated review collection campaign</p>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            This will send an email sequence to your customer asking them to leave a review on Google, Facebook, or Yelp.
          </p>
          
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 text-xs">✓</span>
              </span>
              Day 1: Initial request
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 text-xs">✓</span>
              </span>
              Day 3: Friendly reminder
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 text-xs">✓</span>
              </span>
              Day 7: Follow-up
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 text-xs">✓</span>
              </span>
              Day 14: Final reminder
            </div>
          </div>
          
          <p className="text-xs text-gray-500 mt-3">
            Emails stop automatically when a review is received.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <p className="text-sm font-medium text-gray-700">Customer Details:</p>
          <p className="text-gray-900">{customerFullName}</p>
          <p className="text-blue-600">{estimate?.customer_email}</p>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isRequesting || !estimate?.customer_email}
            className="flex-1 bg-yellow-500 hover:bg-yellow-600"
          >
            <Star className="w-4 h-4 mr-2" />
            {isRequesting ? 'Sending...' : 'Start Campaign'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReviewRequestModal;
